import { render, staticRenderFns } from "./IntegratorContracts.vue?vue&type=template&id=99ca2390&scoped=true&"
import script from "./IntegratorContracts.vue?vue&type=script&lang=js&"
export * from "./IntegratorContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ca2390",
  null
  
)

export default component.exports